import { configureStore } from '@reduxjs/toolkit';
import user from './modules/user';
// import modal from './modules/modal';
const store = configureStore({
  reducer:{
    user
  }
});

export default store;